
import { ref, shallowRef/* , computed */ } from '@vue/composition-api';
import { 
  LayoutFieldItem
} from '../model/layout';

export const useDraggable = () => {
  const isDragging = ref<boolean>(false);
  const dragFromCode = ref<string | null>(null);
  const dragTargetInfo = shallowRef<LayoutFieldItem | null>(null);
  const dragTargetCode = ref<string | null>(null);

  // 更新拖拽状态
  const updateDragStatus = (
    status: boolean, 
    fieldCode?: string, 
    fieldInfo?: LayoutFieldItem,
    fromAreaCode?: string
  ) => {
    isDragging.value = status;

    if (!status) {
      dragTargetInfo.value = null;
      dragTargetCode.value = null;
      dragFromCode.value = null;
      return;
    }

    dragTargetCode.value = fieldCode || null;
    dragTargetInfo.value = fieldInfo || null;
    dragFromCode.value = fromAreaCode || null;
  };

  return {
    isDragging,
    dragTargetInfo,
    dragTargetCode,
    dragFromCode,
    updateDragStatus
  };
};

export type draggableStore = ReturnType<typeof useDraggable>;